import { Injectable } from '@angular/core';
import { VariableTypeEnum } from '../../../../shared/ontology/variable-type.enum';
import { PreviewCrossesModel } from '../../../../shared/study/model/preview-crosses.model';
import { ImportCrossesResponseModel } from '../../../../shared/study/model/import-crosses.response.model';

@Injectable({ providedIn: 'root' })
export class ImportCrossesContext {
    datasetId: number;
    studyId: number;
    studyName: string;
    isEnvironmentsImportBoolean: boolean;
    isStudySettingsImportBoolean: boolean;
    variableTypeIds: VariableTypeEnum[] = [];
    excludedVariableIds: number[];
    listMetadata: ImportCrossesResponseModel;
    crosses: PreviewCrossesModel[] = [];
}
